import styled from '@emotion/styled';

import { breakPoints, mq } from '@/utility/mediaQuery';

const breakPointKeys = Object.keys(breakPoints);

interface BreakProps {
  breakpoint: keyof typeof breakPoints;
  isHidden?: boolean;
}

const Break = styled.br((props: BreakProps) => {
  const breakPointIndex = breakPointKeys.indexOf(props.breakpoint);
  return mq({
    display: breakPointKeys.map((_, i) => {
      if (i < breakPointIndex) {
        return props.isHidden ? 'block' : 'none';
      }
      return props.isHidden ? 'none' : 'block';
    }),
  });
});

export default Break;
